/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { FormControl } from 'react-bootstrap';
import { Button } from 'edrolo-style-guide';
import style from './QuestionView.scss';
import questionTypePropInterface from '../../questionTypePropInterface';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

const AnswerTextBox = ({ value, onChange, rows, className }) => (
  <div className={className}>
    <FormControl
      componentClass="textarea"
      rows={rows}
      placeholder="Write your answer"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      data-test="checklist-question-answer-text-input"
    />
  </div>
);

class QuestionView extends Component {
  static defaultProps = {
    submittedText: null,
  };

  state = {
    submittedText: '',
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.question !== this.props.question) {
      this.setState({ submittedText: '' });
    }
  }

  get hasUnsubmittedText() {
    return !!this.state.submittedText;
  }

  render() {
    const { question, onSubmit, onSubmitTeacherAnswer } = this.props;

    return (
      <div data-test={`question-${EXAM_QUESTION_TYPES.TEXT_CHECKLIST}`}>
        <AnswerTextBox
          value={this.state.submittedText}
          onChange={(value) => this.setState({ submittedText: value })}
          rows={question.get('number_of_lines')}
          className={style.answerTextBox}
        />
        <Button
          onClick={() => {
            onSubmitTeacherAnswer
              ? onSubmitTeacherAnswer()
              : onSubmit({ submittedText: this.state.submittedText });
          }}
          disabled={!this.hasUnsubmittedText}
          data-test={`submit-${EXAM_QUESTION_TYPES.TEXT_CHECKLIST}`}
        >
          {onSubmitTeacherAnswer ? 'View answer' : 'Submit'}
        </Button>
      </div>
    );
  }
}

QuestionView.propTypes = {
  ...questionTypePropInterface,
};

export default QuestionView;
